import { Chip } from '@mui/material';

type InputContentChipProps = {
	label: string;
};

/**
 * A standardized chip component for displaying input content summaries.
 * Used by various InputContent components to show a concise representation
 * of the configured value (e.g., "3 columns", "5 tabs").
 */
export default function InputContentChip({ label }: InputContentChipProps) {
	return (
		<Chip
			label={label}
			size="small"
			variant="outlined"
			color="primary"
			sx={{
				maxWidth: '100%',
				'& .MuiChip-label': {
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				},
			}}
		/>
	);
}
